<template>
  <div>
    <choice-options
      v-if="isChoice"
      :question="question"
      @change="onChange"
      :selectedOptionId="answer.selectedOptionId"
      :disabled="disabled">
      <template slot="append"
                slot-scope="prop">
        <slot name="append"
              :option="prop.option"></slot>
      </template>
    </choice-options>
    <multitext-option
      v-else
      :question="question"
      @change="onChange"
      :texts="answer.texts"
      :disabled="disabled"/>
  </div>
</template>

<script>
import ChoiceOptions from './ChoiceOptions'
import MultitextOption from './MultitextOption'
import QuestionReview from '../../question-review.js'

export default {
  components: {ChoiceOptions, MultitextOption},
  mixins: [],
  props: {
    question: Object,
    questionIndex: Number,
    answer: Object,
    disabled: Boolean,
  },
  data () {
    return {}
  },
  computed: {
    isChoice () {
      return QuestionReview().isChoice(this.question.id)
    },
  },
  watch: {},
  beforeCreate () {},
  created () {
    this.$nextTick(() => {})
  },
  mounted () {},
  destroyed () {},
  methods: {
    onChange (val) {
      this.$emit('change', val)
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/packages/QuestionOption/index.vue